import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { MainService } from "src/app/app.service";

/**
 * Restringe a Gestão de usuários a quem o backend autoriza a ler usuários (`user:read`).
 *
 * Quem decide é o backend, via probe em `/access/catalog`: mesma permissão da tela (`user:read`),
 * mas leve (o resumo de acessos, que a tela carrega em seguida, agrega todos os usuários).
 * Os headers não usam X-PO-No-Message, então o motivo do 403 é exibido pelo toaster
 * app-level do PO; o guard não emite toast próprio nem redireciona, só cancela a navegação.
 */
@Injectable({
  providedIn: "root",
})
export class UsersAdminGuard {
  constructor(
    private http: HttpClient,
    private mainService: MainService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.http.get("/api/v2/access/catalog", this.mainService.httpOptions).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
